import pushClevertapEvent from '../pushClevertapEvent';

export function forgotPasswordStart({ email }) {
  pushClevertapEvent('Forgot Password Start', {
    Credentials: email,
  });
}
